module.exports = __webpack_public_path__ + "static/a-xx-039-art-e9a3c00f324ae2809c34013d5fa2504c.jpg";